import { useCallback, useRef } from 'react';

import { pushRegistrationFillingStartEvent } from 'src/helpers/customGtmEvents168';

const useRegistrationFillingStartEvent = () => {
  const hasRegistrationFillingStartedRef = useRef(false);

  const handleFieldInteraction = useCallback(event => {
    if (hasRegistrationFillingStartedRef.current) {
      return;
    }

    if (event.type === 'click' && !event.target.closest('.checkbox-container')) {
      return;
    }

    hasRegistrationFillingStartedRef.current = true;
    pushRegistrationFillingStartEvent();
  }, []);

  return handleFieldInteraction;
};

export default useRegistrationFillingStartEvent;
